import { createContext } from 'react';

export default createContext<{
  _: (msg: string, replace: any) => string;
  messageReady: boolean;
}>({
  _: (msg: string, replace: any) => ' ',
  messageReady: false
});
